<!--
 * @Author: 王佳宾
 * @Date: 2022-09-29 13:31:20
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-06-14 09:52:11
 * @Description: 矿业项目--数据管理
 * @FilePath: \web\src\views\Project\Manager\DataManagement.vue
-->
<template>
  <section class="data-container">
    <a-tabs v-model:activeKey="activeKey" class="data-container-tabs">
      <a-tab-pane v-for="item in tabsList" :key="item.key" :tab="item.name" v-bind="item.option">
        <component :is="item.component"></component>
      </a-tab-pane>
    </a-tabs>
  </section>
</template>

<script setup>
import { onMounted, ref, reactive, getCurrentInstance, } from 'vue';
import config from '@/config/config';
import Management from '@/components/DataManagement/management/index.vue';
import DataAudit from '@/components/DataManagement/audit/index.vue';

const activeKey = ref('1');
const tabsList = ref([{
  key: '1',
  name: '数据管理',
  option: {
    forceRender: false,
  },
  component: Management,
},])

config.getPermissionId() === 1 ? tabsList.value.push(
  {
    key: '2',
    name: '数据审核',
    operation: [1,],
    option: {
      forceRender: true,
    },
    component: DataAudit,
  },
) : '';

</script>

<style lang="scss">
.data-container {
  background-color: rgba(179, 150, 92, 0.05);
  height: 100%;

  /* tabs */
  .data-container-tabs {
    height: 100%;

    /* 头 */
    .ant-tabs-top-bar {
      height: 0.5rem;
    }

    /* 内容区 */
    .ant-tabs-content {
      height: calc(100% - 0.5rem);

      .ant-tabs-tabpane {
        height: 100%;
      }
    }

    .ant-tabs {
      overflow: inherit;
    }

    .ant-tabs-nav-container {
      // background-color: rgba(10, 7, 0, 0.4);
    }

    .ant-tabs-ink-bar {
      background-color: transparent;
    }

    .ant-tabs-nav {
      .ant-tabs-tab:active {
        color: #fff;
        background-color: rgba(43, 34, 8, 0.7);
      }

      .ant-tabs-tab:hover {
        color: #fff;
        background-color: rgba(43, 34, 8, 0.7);
      }
    }

    .ant-tabs-bar {
      margin: 0;
      border-bottom: none;

      .ant-tabs-tab {
        color: rgba(255, 255, 255, 0.6);
        font-size: 0.16rem;
      }

      .ant-tabs-tab-active {
        color: #fff;
      }
    }
  }
}
</style>
